/*!
 * Copyright (c) 2018-present Cyclope.ai
 * LICENSE file is in the root directory of this source tree.
 * */

import * as actions from '@tunnel-enums/index';
import {CombinesObjectModels} from '@tunnel-models/index';
import * as actionsTypesFromStore from '@tunnel-store/index';
import {Reducer} from 'redux';

/**
 * @function LogoutReducer
 * @param { any } sate: L'etat de l'application
 * @param {  actionsTypesFromStore.TypeLogoutAction } action: action de
 *     l'application
 * @return { Reducer }
 */
export const LogoutReducer: Reducer<CombinesObjectModels<any>> =
    (state: any = {

     }, action: actionsTypesFromStore.TypeLogoutAction) => {
      switch (action.type) {
        case actions.LogoutActionTypes.LOGOUT_INPROGRESS:

          return {
            loading: true, ...state
          }

          break;
        case actions.LogoutActionTypes.LOGOUT_FAIL:

          return {
            error: [action.payload.error], loading: false,
          }

          break;

        case actions.LogoutActionTypes.LOGOUT_SUCCESS:

          return {
            error: null, loading: false,
          }

          break;

        default:
          return state
          break;
      }
    }


// WEBPACK FOOTER //
// ./src/apps/tunnel/store/reducers/logout/index.ts